import axios from 'axios';
import qs from 'qs';
import { PortalModeType, } from '../types';
import { ApiStatus, getResponseData, isResponseStatusSuccess } from './api.utils';
import { managerAxios } from './baseApis';
export const refresh = async () => {
    const endpoint = '/user/refresh';
    const response = await axios.put(endpoint);
    if (!isResponseStatusSuccess(response?.status)) {
        return {
            status: ApiStatus.Failed,
            errorText: response?.statusText ?? 'Unknown error',
        };
    }
    else {
        return { status: ApiStatus.Loaded };
    }
};
export const deleteUser = async () => {
    const endpoint = '/user';
    const response = await axios.delete(endpoint);
    if (!isResponseStatusSuccess(response?.status)) {
        return {
            status: ApiStatus.Failed,
            errorText: response?.statusText ?? 'Unknown error',
        };
    }
    else {
        return { status: ApiStatus.Loaded };
    }
};
export const getUser = async (shareId, managerInviteCode) => {
    const queryString = qs.stringify({ managerInviteCode, shareId }, { skipNulls: true });
    const endpoint = `user${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
export const getManagerUser = async () => {
    const endpoint = 'user';
    const response = await managerAxios.get(endpoint);
    return getResponseData(response);
};
export const isManager = async () => {
    const endpoint = 'user/isManager';
    const response = await axios.get(endpoint);
    return getResponseData(response);
};
export const getMode = async () => {
    const endpoint = 'user/getMode';
    try {
        const response = await managerAxios.get(endpoint);
        return getResponseData(response);
    }
    catch (error) {
        if (axios.isAxiosError(error) && error?.response?.status === 401) {
            return { status: ApiStatus.Loaded, data: { portalMode: PortalModeType.Employee } };
        }
    }
};
export const switchMode = async (mode) => {
    const endpoint = 'user/switchMode';
    const response = await managerAxios.put(endpoint, { mode });
    return getResponseData(response);
};
export const removeEmployee = async (employeeUserId) => {
    const removeEndpoint = `user/removeEmployee/${employeeUserId}`;
    return await axios.post(removeEndpoint);
};
export const managerInviteCode = async () => {
    const managerInviteCodeEndpoint = `user/ManagerInviteCode`;
    return await axios.post(managerInviteCodeEndpoint);
};
export const managerDetails = async (managerInviteCode) => {
    const managerDetailsEndpoint = `user/ManagerDetails?managerInviteCode=${managerInviteCode}`;
    return await axios.get(managerDetailsEndpoint);
};
export const getDirectReports = async () => {
    const directReportsEndpoint = `user/directReportsOptions`;
    return await managerAxios.get(directReportsEndpoint);
};
